import { ModelSagres } from "@/types/model-sagres";

export class UgResumido extends ModelSagres {
    Id: number
    CodUgSagres: string
    UgNmNome: string
    IdStatus: number
    MunicipioNmNome: string

    constructor(obj?: any) {
        super()
        if (obj) {
            if (obj.Id) this.Id = obj.Id
            if (obj.CodUgSagres) this.CodUgSagres = obj.CodUgSagres
            if (obj.NmNome) this.UgNmNome = obj.NmNome
            if (obj.IdStatus) this.IdStatus = obj.IdStatus
            if (obj.IdMunicipioNavigation) this.MunicipioNmNome = obj.IdMunicipioNavigation.NmNome
        }
    }
}
